<template lang="pug">
div
  liondesk-dialog(
    v-model="isModalVisible"
    hide-cancel-button
    dialogTitle="Hey do something with this"
    :dialogBody="dialogBody"
    @click:ok="isModalVisible = false"
  )
  sorting-modal(
    v-model="mockData"
    ref="hotnessSortingModal"
    sorting-field="rank"
    label-field="hotness"
    :resource="pluralResource"
    @input="handleSort"
  )
  resource-table(
    item-key="id"
    can-show-admin-resources
    show-sort-action
    :headers="mockHeaders"
    :items="mockData"
    :singular-resource="singularResource"
    :plural-resource="pluralResource"
    :place-holder-item="placeHolderItem"
    :should-save="isFormValid"
    :selected-label="selectedLabel"
    :is-loading="isLoading"
    :affected-count="10"
    :show-success-message="showSuccess"
    :show-error-message="showError"
    additional-message="This is an additional space for a message."
    @create="handleCreate"
    @edit="handleEdit"
    @cancel="handleCancel"
    @save:create="handleSaveCreate"
    @save:edit="handleSaveEdit"
    @delete="handleDelete"
    @selected-item="setSelectedId"
    @sort="openSortModal"
    @clear-messages="clearMessages"
  )
    template(slot="items" slot-scope="props")
      td
        span # {{ props.item.rank }}
      td
        editable-text-field(
          v-model="props.item.hotness"
          :is-editing="shouldEdit(props.item.id)"
          :rules="rules"
          @update:error="handleError"
        )
      td
        editable-color-picker(v-model="props.item.color" :is-editing="shouldEdit(props.item.id)")
      td
        editable-drop-down(
          v-model="props.item.type"
          :is-editing="shouldEdit(props.item.id)"
          :items="typeValues"
          :rules="rules"
          @update:error="handleError"
        )
</template>

<script>
import LiondeskDialog from '@/Core/components/LiondeskDialog';
import ResourceTable from './ResourceTable';
import EditableTextField from './EditableTextField';
import EditableColorPicker from './EditableColorPicker';
import EditableDropDown from './EditableDropDown';
import SortingModal from './SortingModal';

export default {
  name: 'POC',
  components: {
    LiondeskDialog,
    ResourceTable,
    EditableTextField,
    EditableColorPicker,
    EditableDropDown,
    SortingModal,
  },
  data() {
    return {
      isModalVisible: false,
      dialogBody: '',
      selectedId: '',
      isFormValid: true,
      singularResource: 'Hotness',
      pluralResource: 'Hotnesses',
      placeHolderItem: { id: 0, hotness: 'New Hotness', color: '#aa00aa', type: 'personal' },
      mockHeaders: [
        { text: 'Rank', value: 'rank', width: '10%' },
        { text: 'Hotness', value: 'hotness' },
        { text: 'Color', value: 'color' },
        { text: 'Type', value: 'type' },
      ],
      mockData: [
        { id: 3, hotness: 'Searching', color: '#f83921', type: 'internal', rank: 3 },
        { id: 4, hotness: 'Warm', color: '#ffd136', type: 'internal', rank: 4 },
        { id: 6, hotness: 'Searching', color: '#f83921', type: 'internal', rank: 6 },
        { id: 2, hotness: 'Fire', color: '#ff7537', type: 'personal', rank: 2 },
        { id: 12, hotness: 'Searching', color: '#f83921', type: 'internal', rank: 12 },
        {
          id: 5,
          hotness: 'Fire',
          color: '#ff7537',
          type: 'personal',
          disabled_by: 'system',
          rank: 5,
        },
        {
          id: 1,
          hotness: 'Warm',
          color: '#ffd136',
          type: 'internal',
          disabled_by: 'system',
          rank: 1,
        },
        { id: 7, hotness: 'Warm', color: '#ffd136', type: 'internal', rank: 7 },
        { id: 9, hotness: 'Searching', color: '#f83921', type: 'internal', rank: 9 },
        {
          id: 10,
          hotness: 'Warm',
          color: '#ffd136',
          type: 'internal',
          disabled_by: 'subadmin',
          rank: 10,
        },
        {
          id: 11,
          hotness: 'Fire',
          color: '#ff7537',
          type: 'personal',
          disabled_by: 'subadmin',
          rank: 11,
        },
        { id: 8, hotness: 'Fire', color: '#ff7537', type: 'personal', rank: 8 },
      ],
      typeValues: ['internal', 'personal'],
      rules: [v => !!v || 'req'],
      isLoading: false,
      isDelete: false,
      showSuccess: false,
      showError: false,
    };
  },
  watch: {
    isModalVisible(val) {
      if (val) return;
      this.selectedId = null;
      setTimeout(() => {
        this.isLoading = false;
        if (this.isDelete) {
          this.isDelete = false;
          this.showError = true;
        } else {
          this.showSuccess = true;
        }
      }, 2000);
    },
    selectedId() {
      this.isFormValid = true;
    },
  },
  computed: {
    selectedLabel() {
      const item = this.mockData.find(i => i.id === this.selectedId);
      return item && item.hotness;
    },
  },
  methods: {
    handleEdit(itemId) {
      this.selectedId = itemId;
    },
    handleCancel() {
      this.selectedId = null;
      this.isDelete = false;
    },
    handleCreate() {
      this.selectedId = 0;
    },
    handleSaveCreate(item) {
      this.dialogBody = 'You need to create this ' + JSON.stringify(item);
      this.isModalVisible = true;
      this.isLoading = true;
    },
    handleSaveEdit(item) {
      this.dialogBody = 'You need to save this ' + JSON.stringify(item);
      this.isModalVisible = true;
      this.isLoading = true;
    },
    handleDelete(item) {
      this.dialogBody = 'You need to delete this ' + JSON.stringify(item);
      this.isModalVisible = true;
      this.isLoading = true;
    },
    shouldEdit(itemId) {
      if (this.selectedId === null) return false;
      return this.selectedId === itemId && !this.isDelete;
    },
    handleError(value) {
      // if there is error it throws true
      this.isFormValid = !value;
    },
    setSelectedId(itemId) {
      this.isDelete = true;
      this.selectedId = itemId;
    },
    handleSort(items) {
      this.dialogBody =
        'You need to update the items, they were rearranged ' + JSON.stringify(items);
      this.isModalVisible = true;
      this.isLoading = true;
      this.mockData = items;
    },
    openSortModal() {
      this.$refs.hotnessSortingModal.modal_open();
    },
    clearMessages() {
      this.showError = false;
      this.showSuccess = false;
    },
  },
};
</script>
